var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190 78L190 106",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.5,
    cy: 73.3333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.987 73.1898C185.987 69.2835 189.288 66.1168 193.358 66.1168C193.943 66.1168 194.511 66.1841 195.056 66.3076C193.742 65.4804 192.187 65 190.519 65C185.814 65 182 68.8056 182 73.5C182 78.1944 185.814 82 190.519 82C192.814 82 194.895 81.0929 196.427 79.6205C195.492 80.0317 194.454 80.2628 193.358 80.2628C189.288 80.2628 185.987 77.0961 185.987 73.1898Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.402 72.6003L199.37 70.1461L197.536 71.7189L195.304 71.0564L196.112 73.3367L194.765 75.3813L197.1 75.2179L198.499 77.144L199.133 74.7627L201.345 73.9085L199.402 72.6003Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch8);
export default __webpack_public_path__ + "static/media/church_8.a0fd88fbca723acb7fdb344ea2851040.svg";
export { ForwardRef as ReactComponent };